"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendCodeMultichannel = sendCodeMultichannel;
var _index = require("./index");
var _view = require("../../types/view");
var _view2 = require("../view");
var _sendTwoFactorCode = require("../../api/sendTwoFactorCode");
function sendCodeMultichannel() {
  return async (dispatch, getState, context) => {
    const {
      subdomain
    } = context;
    const state = getState();
    const phone = state.authentication.twoFactor.phoneState.phone;
    const login = state.login;
    const password = state.authentication.password;
    const activeView = state.view.active;
    dispatch((0, _index.sendCodeLoading)());
    const result = await (0, _sendTwoFactorCode.sendTwoFactorCodeMultichannel)(context, {
      subdomain,
      phone,
      login,
      password
    });
    if (result.status === _sendTwoFactorCode.ESendTwoFactorCodeStatus.Failed) {
      dispatch((0, _index.sendCodeFailed)(result.message));
      return;
    }
    dispatch((0, _index.sendCodeSucceed)(result));
    if (result.senderType === _sendTwoFactorCode.ESenderType.Sms && activeView !== _view.EActiveView.TwoFactorPhoneValidateSms) {
      dispatch((0, _view2.changeView)(_view.EActiveView.TwoFactorPhoneValidateSms));
    }
    if (result.senderType === _sendTwoFactorCode.ESenderType.Call && activeView !== _view.EActiveView.TwoFactorPhoneValidateCall) {
      dispatch((0, _view2.changeView)(_view.EActiveView.TwoFactorPhoneValidateCall));
    }
  };
}